import * as React from "react";
const SvgEmpty = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props });
export default SvgEmpty;
